export default {
  comments: {
    title: 'Comments',
    fillerMessage:
      'Enhance collaboration with others by creating a thread. Click anywhere on the map to add a comment.',
    addCommentPlaceholder: 'Add a comment',
    replies: '{count, plural, =1 {# reply} other {# replies}}',
    resultBy: '{count, plural, =1 {# result by} other {# results by}}',
    deletedUser: 'Deleted User',
    unread: 'Unread',
    editedTag: '(edited)',
    filters: {
      tooltip: 'Filters',
      all: 'All',
      myComments: 'My comments',
      onlyUnread: 'Only unread'
    },
    searchPlaceholder: 'Search comments',
    noComments: 'No comments were found',
    noCommentsMessage: `Try adjusting your search to find the comments you're looking for, or adjust your filters.`,
    resetFilters: 'Show the whole comments list',
    resolved: 'Resolved',
    includeResolved: 'Include resolved',
    markAllAsRead: 'Mark all as read',
    showCommentsOnMap: 'Show comments on map',
    hideCommentsOnMap: 'Hide comments on map',

    actions: {
      showComments: 'Show comments',
      hideComments: 'Hide comments',
      copyLink: 'Copy link',
      markAsResolved: 'Mark as resolved',
      deleteThread: 'Delete thread',
      deleteComment: 'Delete comment',
      reopen: 'Re-open',
      moreActions: 'More actions',
      edit: 'Edit'
    },
    actionTypes: {
      resolved: 'Marked as resolved',
      reopened: 'Re-opened'
    },
    notifications: {
      commentsHidden: 'Comments hidden',
      commentsShown: 'Comments shown',
      commentsMarkedAsRead: '{count, plural, =1 {# thread marked as read} other {# threads marked as read}}',
      commentDeleted: 'Comment deleted',
      threadDeleted: 'Thread deleted',
      commentResolved: 'Comment resolved',
      commentReopened: 'Comment re-opened',
      linkCopied: 'Link copied to clipboard!'
    },
    deleteThreadConfirm: {
      title: 'Delete thread',
      message: `Are you sure you want to delete this thread? This action can't be undone.`
    },
    deleteCommentConfirm: {
      title: 'Delete comment',
      message: `Are you sure you want to delete this comment? This action can't be undone.`
    },
    popover: {
      commentNo: 'Comment #',
      addComment: 'Add a comment',
      reply: 'Reply',
      replyWillReopen: 'Replying will re-open the thread...'
    },
    maxSuggestionExceededMessage: 'Too many results, please refine your search',
    noSuggestionsMessage: 'No users with access were found'
  }
}
